<div
  class="side-sheet"
  [class.side-sheet__layer]="isLayer()"
  [@slide]="
    isLayer()
      ? slideAnimationStateEnum.OPEN
      : slideAnimationStateEnum.CLOSED_RIGHT
  "
  [elevation]="isLayer() ? 2 : 0"
  appElevation
>
  <div
    class="side-sheet__header"
    [class.side-sheet__header--bordered]="!contents().length"
  >
    <div class="side-sheet__header-content">
      <div class="d-flex justify-content-between">
        <div>
          <ng-content select="[control-panel]"></ng-content>
        </div>
        <div class="d-flex">
          @if (showEditButton()) {
            <div
              class="icon icon--edit app-click-area mb-0 ps-3"
              (click)="editEntryClicked()"
            ></div>
          }
          <div
            class="icon icon--close app-click-area mb-0 ps-3"
            (click)="dismiss()"
          ></div>
        </div>
      </div>
      <div class="d-flex flex-nowrap justify-content-between">
        <ng-content select="[header-title]"></ng-content>
      </div>
      <ng-content select="[header-subtitle]"></ng-content>
    </div>
    <div class="side-sheet__header-nav">
      <nav
        [keyboard]="'changeWithArrows'"
        ngbNav
        #navigation
        #nav="ngbNav"
        [(activeId)]="activeNav"
        class="nav-pills"
        [class]="{
          'side-sheet__header-nav--fade-left': leftFade,
          'side-sheet__header-nav--fade-right': rightFade
        }"
        (scroll)="onHorizontalScroll()"
        (wheel)="onWheelScroll($event)"
      >
        @for (content of contents(); track content.label(); let i = $index) {
          <ng-container
            ngbNavItem="nav-{{ i }}"
            [disabled]="
              content?.disabled() ||
              (!isFormValid() && currentFormIndex() < i) ||
              (disableActions() && currentFormIndex() !== i)
            "
          >
            <a draggable="false" ngbNavLink (click)="scrollIntoView(i)">
              {{ content?.label() | translate }}
              @if (content?.required()) {
                <span>*</span>
              }
            </a>
          </ng-container>
        }
      </nav>
    </div>
  </div>

  @if (contents()?.length) {
    <div class="side-sheet__content">
      <ng-template
        [ngTemplateOutlet]="contents()?.at(currentFormIndex())?.template"
      ></ng-template>
    </div>
  }

  <div class="side-sheet__footer" [class.w-100]="useFullWidth()">
    <div
      class="side-sheet__footer-button-container"
      [class.w-100]="useFullWidth()"
    >
      @if (showDefaultFooterButtons()) {
        @if (!singleSubmitButton()) {
          @if (currentFormIndex() !== 0) {
            <button
              im-button
              class="inverted"
              [disabled]="isPending() || disableActions()"
              (click)="switchToTab(-1)"
            >
              {{ 'general.previous_a' | translate }}
            </button>
          }
          <button
            im-button
            class="primary"
            [disabled]="isNextStepDisabled || isPending()"
            (click)="
              currentFormIndex() >= contents().length - 1
                ? save()
                : switchToTab(1)
            "
          >
            @if (isPending()) {
              <im-spinner iconStart class="sm" />
            }
            {{
              (currentFormIndex() >= contents().length - 1
                ? 'general.complete_a'
                : 'general.next_a'
              ) | translate
            }}
          </button>
        }
        @if (singleSubmitButton()) {
          <button
            im-button
            class="primary"
            [disabled]="!isFormValid() || disableActions() || isPending()"
            (click)="save()"
          >
            @if (isPending()) {
              <im-spinner iconStart class="sm" />
            }
            {{ singleSubmitButton() | translate }}
          </button>
        }
      }
      @if (showCustomFooterButtons()) {
        <ng-content select="[footer-buttons]"></ng-content>
      }
    </div>
  </div>
</div>
